/* eslint-disable react/jsx-pascal-case */
import React from "react";
import Joi from "joi-browser";
import { Popover, OverlayTrigger } from "react-bootstrap";
import Phone_textbox from "../../../BprmControls/Phone_textbox";
import SSN_textbox from "../../../BprmControls/SSN_textbox";
import Other_textbox from "../../../BprmControls/Other_textbox";
import {
  formatPhoneNumber,
  formatSSNNumber,
} from "../../../services/appService";

export default function TextBox(props) {
  const {
    controleId,
    comp,
    stateData: data,
    stateErrors: errors,
    stateSchema: schema,
    codeIsVerified,
    isDisabled,
    handleChange,
    handeOnChange,
    getEvaluatedValue,
  } = props;

  const getPopover = (notes) => {
    const popover = (
      <Popover id="popover-basic" style={{ minWidth: "500px" }}>
        <Popover.Title as="h4">Rule Expression</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <button type="button" className="btn-action-search ml-2" style={{ height: "30px", fontSize: "11px", padding: "0 10px" }}>
          <i className="fa fa-eye mr-2"></i>View Rule
        </button>
      </OverlayTrigger>
    );
  };

  const handleEncryptDecryptedOnChange = (name, valueArray) => {
    let decValue = "";
    for (let index = 0; index < valueArray.length; index++) {
      const element = valueArray[index];
      decValue += element;
    }
    const input = { name: name, value: decValue, type: "text" };
    handleChange(input);
  };

  const handePhoneOnChange = ({ target: input }) => {
    input.value = input.value.replace(/[^\d]/g, "");
    if (input.value.length <= 10)
      handleChange({ name: input.name, value: input.value, type: "text" });
  };

  const handeSsnOnChange = ({ target: input }) => {
    input.value = input.value.replace(/[^\d]/g, "");
    if (input.value.length <= 9)
      handleChange({ name: input.name, value: input.value, type: "text" });
  };

  let inputType = comp?.attributeDataTypes?.type || "";

  const buildFieldSchema = () => {
    let validator;
    if (["phone", "mobile"].includes(inputType)) {
      validator = Joi.string().length(10);
    } else if (inputType === "ssn") {
      validator = Joi.string().length(9);
    } else if (inputType === "email") {
      validator = Joi.string().email({ tlds: { allow: false } });
    } else {
      validator = Joi.any();
    }

    // Optional fields
    if (!comp.isRequired) {
      validator = validator.allow("", null);
    }

    // Required fields
    if (comp.isRequired) {
      validator = validator.required();
    }

    // Label
    if (comp.label && comp.label.trim() !== "") {
      validator = validator.label(comp.label);
    } else {
      validator = validator.label("Field"); // fallback default label
    }

    // Optional custom messages for length
    if (["phone", "mobile", "ssn"].includes(inputType)) {
      validator = validator.options({
        language: {
          string: {
            length: `${comp.label} must be ${inputType === "ssn" ? 9 : 10
              } digits.`,
          },
        },
      });
    }

    return validator;
  };

  schema[controleId] = buildFieldSchema();

  const error = errors[controleId];

  const getFieldIcon = () => {
    if (inputType === "ssn") return "fa-id-card";
    if (["phone", "mobile"].includes(inputType)) return "fa-phone";
    if (inputType === "email") return "fa-envelope";
    if (inputType === "number") return "fa-calculator";
    
    // Custom fallbacks based on label name
    const labelLower = (comp.label || "").toLowerCase();
    if (labelLower.includes("name")) return "fa-user";
    if (labelLower.includes("address")) return "fa-map-marker";
    if (labelLower.includes("city")) return "fa-building";
    if (labelLower.includes("state")) return "fa-globe";
    if (labelLower.includes("zip") || labelLower.includes("postal")) return "fa-hashtag";
    if (labelLower.includes("company") || labelLower.includes("firm")) return "fa-briefcase";
    if (labelLower.includes("rate") || labelLower.includes("fee") || labelLower.includes("price") || labelLower.includes("amount")) return "fa-usd";
    
    return "fa-keyboard-o";
  };

  return (
    <div className={`form-group ${comp.isRequired ? "required" : ""}`} style={{ marginBottom: "16px" }}>
      {/* Rendered for both branches so encrypted fields carry the same label
          treatment as plain ones instead of MUI's floating label. */}
      {comp.label && (
        <label className="form-control-label" htmlFor={controleId} style={{
          fontSize: "11px",
          fontWeight: 700,
          color: "#64748b",
          textTransform: "uppercase",
          letterSpacing: "0.7px",
          marginBottom: "6px",
          display: "flex",
          alignItems: "center",
          gap: "5px"
        }}>
          <i className={`fa ${getFieldIcon()}`} style={{ color: "#94a3b8", fontSize: "11px" }} />
          {comp.label}
        </label>
      )}

      {comp?.encryptionValidate ? (
        <>
          {inputType === "ssn" && (
            <SSN_textbox
              value={data[controleId] || ""}
              label={comp.label}
              isDisabled={isDisabled}
              name={controleId}
              handleOnChange={handleEncryptDecryptedOnChange}
              codeIsVerified={codeIsVerified}
              errors={errors}
              required={comp.isRequired}
              cssclass={comp?.cssclass}
            />
          )}

          {["phone", "mobile"].includes(inputType) && (
            <Phone_textbox
              value={data[controleId] || ""}
              label={comp.label}
              isDisabled={isDisabled}
              name={controleId}
              handleOnChange={handleEncryptDecryptedOnChange}
              codeIsVerified={codeIsVerified}
              errors={errors}
              required={comp.isRequired}
              cssclass={comp?.cssclass}
            />
          )}

          {(inputType === "" ||
            inputType === "email" ||
            inputType === "number") && (
              <Other_textbox
                value={data[controleId] || ""}
                label={comp.label}
                isDisabled={isDisabled}
                name={controleId}
                handleOnChange={handleEncryptDecryptedOnChange}
                codeIsVerified={codeIsVerified}
                errors={errors}
                required={comp.isRequired}
                cssclass={comp?.cssclass}
              />
            )}
        </>
      ) : (
        <>
          <div className="wf-input-wrap">
            <i className={`fa ${getFieldIcon()} wf-input-icon`} aria-hidden="true" />
            
            {inputType === "ssn" && (
              <input
                type="text"
                id={controleId}
                name={controleId}
                className={`form-control ${comp?.cssclass || ""}`}
                value={formatSSNNumber(data[controleId] || "")}
                onChange={handeSsnOnChange}
                disabled={isDisabled}
                placeholder={comp.label || ""}
              />
            )}

            {["phone", "mobile"].includes(inputType) && (
              <input
                type="text"
                id={controleId}
                name={controleId}
                className={`form-control ${comp?.cssclass || ""}`}
                value={formatPhoneNumber(data[controleId] || "")}
                onChange={handePhoneOnChange}
                disabled={isDisabled}
                placeholder={comp.label || ""}
              />
            )}

            {(inputType === "" ||
              inputType === "email" ||
              inputType === "number") && (
                <input
                  type={inputType === "number" ? "number" : "text"}
                  id={controleId}
                  name={controleId}
                  className={`form-control ${comp?.cssclass || ""}`}
                  value={data[controleId] || ""}
                  onChange={(event) =>
                    handeOnChange({
                      target: {
                        name: controleId,
                        value: event.target.value,
                        type: "text",
                      },
                    })
                  }
                  disabled={
                    isDisabled ||
                    controleId === "candidateonboardingform.Rate_hour_Paid_to_Candidate"
                  }
                  readOnly={!!comp?.rule}
                  placeholder={comp.label || ""}
                />
              )}
          </div>

          {comp?.rule && (
            <button
              type="button"
              className="btn-action-search btn-primary-search mt-2"
              onClick={() => getEvaluatedValue(comp)}
              style={{ height: "30px", fontSize: "11px", padding: "0 10px" }}
            >
              Apply Rule
            </button>
          )}

          {error && (
            <div className="alert alert-danger" style={{ marginTop: 6, padding: "5px 10px", fontSize: "11.5px", borderRadius: "7px" }}>
              {error}
            </div>
          )}
        </>
      )}

      {/* View Rule Button */}
      {comp?.rule && getPopover(comp.ruleExpression)}
    </div>
  );
}
